<mat-tab-group
  onsip-mat-tab-table
  (selectedIndexChange)="onSelectedIndexChange($event)"
  mat-stretch-tabs="false"
>
  <mat-tab label="Basic settings">
    <ng-template matTabContent>
      <onsip-admin-voicemail-basic-tab
        [voicemail]="voicemail"
        [lessThanMediumBreakpoint]="(lessThanMediumBreakpoint | async)!"
        (mode)="mode = $event"
      >
      </onsip-admin-voicemail-basic-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="Custom Greeting">
    <ng-template matTabContent>
      <onsip-admin-voicemail-greeting-tab [voicemail]="voicemail" (mode)="mode = $event">
      </onsip-admin-voicemail-greeting-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="Advanced settings">
    <ng-template matTabContent>
      <onsip-admin-voicemail-advanced-tab
        [voicemail]="voicemail"
        [lessThanMediumBreakpoint]="(lessThanMediumBreakpoint | async)!"
        (mode)="mode = $event"
      >
      </onsip-admin-voicemail-advanced-tab>
    </ng-template>
  </mat-tab>
</mat-tab-group>
